import React, { Fragment } from 'react';
import { DialogTitle, DialogContent, DialogActions, Button, Divider, Grid } from '@material-ui/core'

import { AddWaitingPassengerForm, WaitingListTable } from 'components'

export const WaitingListModal = (props) => (
  <Fragment>
    <DialogTitle>Список пасажирів що очікують</DialogTitle>
    <Divider />
    <DialogContent>
      <Grid
        container
        spacing={16}
        direction='column'
      >
        <Grid item>
          <AddWaitingPassengerForm />
        </Grid>
        <Grid item>
          <WaitingListTable />
        </Grid>
      </Grid>
    </DialogContent>
    <DialogActions>
      <Button onClick={props.onClose} color='secondary'>
        Вийти
      </Button>
    </DialogActions>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/WaitingListModal/WaitingListModal.js